import { API_REQUEST, GET_PROPERTY_DOCUMENTS, RESET_PROPERTY_DOCUMENTS } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction } from "../../types";

// Download document action
export const getPropertyDocuments = (roll_num: string, property_id: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/documents/get-docs/${roll_num}/${property_id}`,
        next: GET_PROPERTY_DOCUMENTS,
        method: 'GET',
        authorization: true,
    }
});

export const resetPropertyDocuments = (): AppNoApiAction => ({
    type: RESET_PROPERTY_DOCUMENTS
});
